import { apiGet } from './client';
import type {
  BannerListResponse,
  Game,
  GameListResponse,
  MetaResponse,
  ProviderListResponse,
} from './types';

export function fetchMeta(): Promise<MetaResponse> {
  return apiGet<MetaResponse>('/api/v1/meta');
}

export function fetchBanners(params?: {
  banner_type?: string;
  locale?: string;
}): Promise<BannerListResponse> {
  const locale = (params?.locale || '').trim().toLowerCase().slice(0, 8) || undefined;
  return apiGet<BannerListResponse>('/api/v1/banners', {
    banner_type: params?.banner_type,
    // Explicit locale beats Accept-Language races while i18n is switching.
    locale,
  });
}

export function fetchGames(params?: {
  q?: string;
  provider?: string;
  game_type?: string;
  featured?: boolean;
  page?: number;
  per_page?: number;
}): Promise<GameListResponse> {
  return apiGet<GameListResponse>('/api/v1/games', {
    q: params?.q,
    provider: params?.provider,
    game_type: params?.game_type,
    featured: params?.featured ? 'true' : undefined,
    page: params?.page,
    per_page: params?.per_page,
  });
}

/** Resolve one catalog game by Aggregator id. */
export async function fetchGameById(gameId: string): Promise<Game | null> {
  const id = String(gameId || '').trim();
  if (!id) return null;
  try {
    return await apiGet<Game>(`/api/v1/games/${encodeURIComponent(id)}`);
  } catch {
    return null;
  }
}

export type LobbySections = {
  catalog_total: number;
  daily_date?: string | null;
  pinned_slot_ids?: string[];
  slots: Game[];
  popular: Game[];
  recommended: Game[];
  new: Game[];
  fast: Game[];
  bonus: Game[];
};

export function fetchLobbySections(refresh = false): Promise<LobbySections> {
  return apiGet<LobbySections>('/api/v1/lobby-sections', {
    refresh: refresh ? 'true' : undefined,
  });
}

export function fetchProviders(): Promise<ProviderListResponse> {
  return apiGet<ProviderListResponse>('/api/v1/providers');
}

export function fetchHomepage(): Promise<{
  sections: Record<string, boolean>;
  announcement: string | null;
  banner_autoplay_ms?: number;
}> {
  return apiGet('/api/v1/homepage');
}
